var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{ref:"input",attrs:{"options":_vm.editorOption},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }